/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_DescriptionInputs */

const en_app_description = /** @type {(inputs: App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your own hype-stack!`)
};

/**
* | output |
* | --- |
* | "Create your own hype-stack!" |
*
* @param {App_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const app_description = /** @type {((inputs?: App_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_app_description(inputs)
});